{
  "panel": {
    "title": "Report",
    "previewTitle": "Report Preview",
    "loading": "Loading report...",
    "empty": "No sections generated yet.",
    "emptyTitle": "Nothing generated yet",
    "emptyHint": "Once generation starts, sections and citations will appear here.",
    "loadFailed": "Could not load report.",
    "ariaPreviousVersion": "Previous version",
    "ariaNextVersion": "Next version",
    "ariaEditSection": "Edit section",
    "ariaSaveChanges": "Save changes",
    "ariaCancelEditing": "Cancel editing",
    "tooltipEdit": "Edit",
    "section": {
      "pendingHint": "Content will appear here once generated.",
      "contextUnavailable": "Context retrieval failed for this section. Try regenerating or uploading additional source files.",
      "loading": "Loading section content…",
      "unavailable": "This section reports as complete but has no saved content.",
      "needsAction": "This section has no saved content and needs to be regenerated.",
      "acceptedNoContent": "Accepted — No Content",
      "awaitingExecSummary": "The executive summary is written once every section is complete.",
      "loadFailed": "This section's content could not be loaded.",
      "reload": "Reload content"
    }
  },
  "generation": {
    "starting": "Starting report generation...",
    "generating": "Generating sections...",
    "sectionsCompleted": "{{completed}} of {{total}} sections complete",
    "currentSection": "Generating: {{title}}",
    "complete": "Report drafting complete.",
    "failed": "Report generation failed.",
    "abort": "Abort generation",
    "aborting": "Aborting...",
    "aborted": "Generation aborted.",
    "regenerate": "Regenerate report",
    "regenerating": "Regenerating...",
    "retryFailed": "Retry failed sections",
    "progressSections": "Generating sections: {{completed}} of {{total}} complete",
    "progressSectionsRegenerating": "Generating sections: {{completed}} of {{total}} complete ({{regenerating}} regenerating)",
    "progressCohortWait_one": "Holistic pass pending — {{count}} section awaiting cohort completion",
    "progressCohortWait_other": "Holistic pass pending — {{count}} sections awaiting cohort completion",
    "progressExtractingSymptoms": "Awaiting issue compilation…",
    "progressAggregatingIssues": "Preparing issue log…",
    "progressValidatingReport": "Validating report…",
    "initiatingGeneration": "Initiating generation…",
    "generatingSections": "Generating report sections…",
    "progressExecSummary": "Generating executive summary…",
    "progressAwaitingValidation": "Sections awaiting validation…"
  },
  "section": {
    "untitled": "Untitled section",
    "draft": "Draft",
    "validated": "Self-checked",
    "generating": "Generating...",
    "failed": "Generation failed",
    "regenerate": "Regenerate section",
    "regenerating": "Regenerating...",
    "regenerateConfirm": "Regenerate this section?",
    "regenerateConfirmBody": "The current draft will be replaced. Citations will be re-generated from current files.",
    "feedback": "Provide feedback",
    "feedbackTitle": "Section feedback",
    "feedbackPlaceholder": "What should change about this section?",
    "feedbackSubmit": "Send feedback",
    "feedbackSubmitting": "Sending feedback...",
    "feedbackSent": "Feedback received. Regenerating...",
    "feedbackEmpty": "Please describe your feedback first.",
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "saving": "Saving...",
    "saveFailed": "Could not save edits.",
    "expand": "Expand",
    "collapse": "Collapse",
    "viewSources": "View sources",
    "noContent": "No content yet.",
    "errorBody": "This section failed to generate. Click retry to try again."
  },
  "citation": {
    "viewSource": "View source",
    "openFile": "Open file",
    "page": "Page {{n}}",
    "pages": "Pages {{from}}–{{to}}",
    "evidence": "Evidence",
    "loading": "Loading citation...",
    "loadFailed": "Could not load citation."
  },
  "execSummary": {
    "title": "Executive summary",
    "generating": "Generating summary...",
    "complete": "Summary ready.",
    "failed": "Summary generation failed.",
    "regenerate": "Regenerate summary"
  },
  "holisticValidation": {
    "title": "Holistic self-check",
    "running": "Running cross-section checks...",
    "passed": "All cross-section checks passed.",
    "issuesFound": "{{count}} issue found",
    "issuesFound_other": "{{count}} issues found",
    "viewIssues": "View issues",
    "fixAll": "Fix all",
    "fixing": "Fixing..."
  },
  "export": {
    "button": "Export",
    "buttonDocx": "Export DOCX",
    "buttonPdf": "Export PDF",
    "exporting": "Exporting...",
    "ready": "Export ready.",
    "failed": "Export failed.",
    "downloadHere": "Download",
    "exportTitle": "Export report",
    "format": "Format",
    "includeAppendix": "Include appendix",
    "includeCitations": "Include citation list"
  },
  "artifacts": {
    "title": "Artifacts",
    "showSpec": "Show spec",
    "hideSpec": "Hide spec"
  },
  "execSummaryPinned": {
    "label": "Pinned",
    "tooltip": "You edited this summary, so it is kept as written and is not refreshed automatically. Use Feedback to rewrite it."
  }
}
